const students = {

  edit: {
    tabs: {
      information: 'Informação',
      notes: 'Observações',
      parents: 'Pais',
      caregivers: 'Cuidadores',
      history: 'Histórico',
      bookingHistory: 'Histórico de reservas'
    },
  },
  table: {
    headers: {
      createBtn: 'Criar',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      homeAddress: 'Endereço de casa',
      alternateAddress: 'Endereço Alternativo',
      schoolAddress: 'Escola',
      createdAt: 'Criado em',
    },
  },
  form: {
    header: {
      create: {
        title: 'Criar',
      },

      update: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    actions: {
      header: 'Ações',
      buttons: {
        resetPassword: 'Redefinir Senha',
      },
    },

    create: {
      confirmButtonText: 'Enviar',
      toasts: {
        success: 'Principal criado com sucesso',
        error: 'Ocorreu um erro ao criar o principal',
      },
    },
    update: {
      formTabs: {
        informationTab: 'Informação',
        notesTab: 'Observações',
      },

      activeStatus: {
        statusActive: 'Ativo',
        statusDeactivate: 'Inativa',
      },

      suspend: {
        actionActivate: 'Reativar',
        actionDeactivate: 'Suspender',
        suspendModal: {
          popupTitleDeactivation: 'Suspender passageiro',
          popupTitleActive: 'Motivo de Suspensão',
          popupTitleUnsuspend: 'Motivo de Anular a Suspensão',
          popupSubTitleDeactivation: 'Selecione o motivo da suspensão',
          popupActionActive: 'Reativar Passageiro',
          popupActionDeactivate: 'Suspender passageiro',
        },
      },
      toasts: {
        success: 'Principal atualizado com sucesso',
        error: 'Ocorreu um erro ao atualizar a principal',
        fetchError: 'Ocorreu um erro, por favor, tente novamente.',
      },
    },
    sections: {
      profiles: {
        fields: {
          label: 'Perfis'
        }
      },
      attributes: {
        fields: {
          label: 'Perfis'
        }
      },
      personalDetails: {
        header: 'Detalhes pessoais',
        fields: {
          firstName: {
            label: 'Nome',
          },
          lastName: {
            label: 'Sobrenome',
          },
          email: {
            label: 'E-mail',
          },
          phone: {
            label: 'Telefone',
          },
          additionalPhone: {
            label: 'Telefone adicional',
          },
          gender: {
            label: 'Sexo',
          },
          dateBirth: {
            label: 'Data de nascimento',
          },
        },
      },
      schoolDetails: {
        header: 'Detalhes da Escola',
        fields: {
          school: {
            label: 'Escola',
          },
          academicYear: {
            label: 'Ano lectivo',
            options: {
              default: 'Padrão',
              current: '2023-2024',
            },
          },
          level: {
            label: 'Nível',
          },
          class: {
            label: 'Aula',
          },
        },
      },
      profile: {
        header: 'Perfis',
        fields: {
          profile: 'Perfis',
        },
      },

      addresses: {
        header: 'Endereços dos alunos',
        fields: {
          mainAddress: {
            label: 'Endereço principal',
          },
          alternateAddress: {
            label: 'Endereço Alternativo',
          },
          level: {
            label: 'Nível',
          },
          class: {
            label: 'Aula',
          },
        },
      },
      linkParents: {
        header: 'Pais',
        add: 'Adicionar',
        entity: 'Pais',

        parentsTable: {
          headers: {
            name: 'Nome',
            address: 'Endereço',
            phone: 'Telefone',
            email: 'E-mail',
          },
        },
      },

      linkCaregivers: {
        header: 'Cuidadores',
        add: 'Adicionar',
        entity: 'Cuidadores',

        caregiversTable: {
          headers: {
            name: 'Nome',
            address: 'Endereço',
            phone: 'Telefone',
            email: 'E-mail',
          },
        },
      },
    },
  },
};

export default students;
